<div class="auth-wrapper">
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'mfa.challenge.headline' | transloco }}</h1>

      @switch (state) {
        @case ('loading') {
          <div class="mfa-loading" role="status" aria-live="polite">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        }

        @case ('redirecting') {
          <div class="mfa-loading" role="status" aria-live="polite">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="supporting">{{ 'mfa.common.redirecting' | transloco }}</p>
          </div>
        }

        @case ('challenge') {
          @if (!useRecovery) {
            <p class="supporting">
              {{ (isEmail ? 'mfa.challenge.supportingEmail' : 'mfa.challenge.supportingTotp') | transloco }}
            </p>
            @if (notice) {
              <p class="notice" role="status" data-testid="notice">{{ notice | transloco }}</p>
            }
            <form (submit)="onSubmit($event)" novalidate>
              <app-code-entry
                [length]="codeLength"
                mode="numeric"
                [autofocus]="true"
                [disabled]="submitting"
                [ariaLabel]="'mfa.common.codeLabel' | transloco"
                [cellLabel]="'mfa.common.charLabel' | transloco: {n: '{n}', total: '{total}'}"
                (valueChange)="onCodeChange($event)"
                (completed)="onCodeCompleted($event)"
              />
              @if (error) {
                <p class="error" role="alert" data-testid="error">{{ error | transloco }}</p>
              }
              <button mat-flat-button color="primary" type="submit" [disabled]="!canSubmit">
                {{ (submitting ? 'mfa.challenge.verifying' : 'mfa.challenge.verify') | transloco }}
              </button>
            </form>
            <div class="actions">
              @if (isEmail) {
                <button type="button" mat-button class="secondary-action" data-testid="resend"
                        (click)="resend()" [disabled]="resendIn > 0 || submitting || resending">
                  {{ resendIn > 0 ? ('mfa.common.resendIn' | transloco: {seconds: resendIn}) : ('mfa.common.resend' | transloco) }}
                </button>
              }
              @if (canSwitchMethod) {
                <button type="button" mat-button class="secondary-action" data-testid="switch-method"
                        (click)="switchMethod()" [disabled]="submitting">
                  {{ (isEmail ? 'mfa.challenge.useTotpInstead' : 'mfa.challenge.useEmailInstead') | transloco }}
                </button>
              }
              <button type="button" mat-button class="secondary-action" data-testid="use-recovery" (click)="toggleRecovery()">
                {{ 'mfa.challenge.useRecovery' | transloco }}
              </button>
            </div>
          } @else {
            <p class="supporting">{{ 'mfa.challenge.recoverySupporting' | transloco }}</p>
            <form (submit)="onSubmit($event)" novalidate>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ 'mfa.challenge.recoveryLabel' | transloco }}</mat-label>
                <input matInput [(ngModel)]="recoveryCode" name="recoveryCode" autocomplete="off"
                       spellcheck="false" placeholder="xxxxx-xxxxx" maxlength="32" data-testid="recovery-input" />
              </mat-form-field>
              @if (error) {
                <p class="error" role="alert" data-testid="error">{{ error | transloco }}</p>
              }
              <button mat-flat-button color="primary" type="submit" [disabled]="!canSubmit">
                {{ (submitting ? 'mfa.challenge.verifying' : 'mfa.challenge.useRecoverySubmit') | transloco }}
              </button>
            </form>
            <div class="actions">
              <button type="button" mat-button class="secondary-action" (click)="toggleRecovery()">
                {{ 'mfa.challenge.backToCode' | transloco }}
              </button>
            </div>
          }
          <div class="actions">
            <button type="button" mat-button class="secondary-action" (click)="backToSignIn()">
              {{ 'mfa.common.backToSignIn' | transloco }}
            </button>
          </div>
        }

        @case ('blocked') {
          <p class="error" role="alert" data-testid="blocked">{{ 'mfa.challenge.blocked' | transloco }}</p>
          <div class="actions">
            <button type="button" mat-button class="secondary-action" (click)="backToSignIn()">
              {{ 'mfa.common.backToSignIn' | transloco }}
            </button>
          </div>
        }

        @case ('error') {
          <p class="error" role="alert">{{ 'mfa.common.loadError' | transloco }}</p>
          <div class="actions">
            <button type="button" mat-button class="secondary-action" (click)="backToSignIn()">
              {{ 'mfa.common.backToSignIn' | transloco }}
            </button>
          </div>
        }
      }
    </mat-card-content>
  </mat-card>
</div>
